import React from 'react';

//Composants
import Title from '../../components/Title/Title';
import ContentText from '../../components/content/content-text.jsx';
import SimpleTitle from '../../components/Title/SimpleTitle';
import Content from '../../components/content/content';
import ContentSlider from '../../components/content/content-slider';
import Skills from '../../components/Projects/Skills.jsx';

//Contenus
import sae from '../../assets/content/projets/SAE501.json';

const SAE501 = () => {

    return (
        <div className='projet'>
            <div class="bloc">
                <Title title={sae.title} variant={sae.variant} />
                <ContentText content={sae.description} />


                <div className='content'>
                    <SimpleTitle title="Ma démarche" variant="green" position="left" />
                    <ContentSlider content={sae.partie1} images={sae.slider1} cote={"left"}></ContentSlider>   
                    <ContentSlider content={sae.partie2} images={sae.slider2} cote={"right"}></ContentSlider>

                    <div className='content-text'>
                        <ContentText content={sae.partie3} />
                    </div>

                    <ContentSlider content={sae.partie4} images={sae.slider3} cote={"right"}></ContentSlider>
                </div>
            </div>

            <div className='skills bloc'>
                <SimpleTitle title="Technologies utilisées" variant="white" position="left" />
                <div className='skills-grid'>
                    {sae.technologies.map((tech, index) => (
                    <Skills
                        image={tech.image}
                        alt={tech.alt}
                        competence={tech.name}
                        centered={tech.bool}
                    />
                ))}
                </div>
            </div>
            <div className='competences bloc'>
                <SimpleTitle title="Compétences et apprentissages critiques mobilisés" variant="purple" position="left" />
                <Content content={sae.competences} image={{thumb: sae.imgcompetences,hd: sae.imgcompetencesgrd}} alt={sae.altcompetencesgrd} cote={"left"} width={sae.widthcompetences} height={sae.heightcompetences} title="Illustration des compétences"></Content>
            </div>
            
        </div>
    );
};

export default SAE501;